function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Box, Container, Divider, Flex, Image, Link, Text } from '../../../components';
import { tqc, useStyleConfig } from '../../../system';
import { NIFooterMenu } from './NIFooterMenu';
import { NIFooterAuthorities } from './authorities/NIFooterAuthorities';
import { FooterLogos } from './footerLogos';
export var NIFooter = _ref => {
  var {
    submissionUrl = '',
    searchUrl = '',
    enforcementUrl = '',
    certificateUrl = '',
    termsConditionsUrl = '',
    openDataUrl = ''
  } = _ref;
  var styles = useStyleConfig('NIFooter', {}, {
    isMultiPart: true
  });
  return /*#__PURE__*/React.createElement(tqc.div, {
    as: "footer",
    className: "tqc-footer"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: styles.mainContainer
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Link, {
    href: "/",
    target: "_blank",
    title: "NI",
    sx: _objectSpread({}, styles.logoLinkStyle)
  }, /*#__PURE__*/React.createElement(Image, {
    src: FooterLogos.niLogo,
    alt: "Planning Portal",
    w: {
      base: '11rem',
      md: '20.5rem',
      lg: '22rem'
    },
    h: {
      base: '2.5rem',
      md: '4.5rem'
    }
  })), /*#__PURE__*/React.createElement(Divider, {
    sx: styles.divider
  }), /*#__PURE__*/React.createElement(NIFooterMenu, {
    submissionUrl: submissionUrl,
    searchUrl: searchUrl,
    enforcementUrl: enforcementUrl,
    certificateUrl: certificateUrl,
    termsConditionsUrl: termsConditionsUrl,
    openDataUrl: openDataUrl
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: styles.authoritiesContainer
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Text, {
    sx: styles.authoritiesHeading
  }, "Participating authorities"), /*#__PURE__*/React.createElement(NIFooterAuthorities, null))), /*#__PURE__*/React.createElement(Box, {
    sx: styles.legalInfoContainer
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Flex, {
    flexWrap: {
      base: 'wrap',
      lg: 'nowrap'
    },
    justifyContent: {
      base: 'flex-start',
      lg: 'center'
    },
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    sx: styles.legalInfoText
  }, "The Planning Portal is developed and powered by TerraQuest. All content \xA9", ' ', new Date().getFullYear(), " Planning Portal."), /*#__PURE__*/React.createElement(Flex, {
    flexBasis: {
      base: '100%',
      lg: 'auto'
    },
    justifyContent: {
      base: 'flex-start',
      lg: 'center'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: "https://www.terraquest.co.uk",
    target: "_blank",
    sx: _objectSpread({}, styles.logoLinkStyle)
  }, /*#__PURE__*/React.createElement(Image, {
    src: FooterLogos.tqLogo,
    alt: "TerraQuest Logo",
    ml: {
      lg: '2rem'
    },
    w: {
      base: '8.7rem',
      md: '10.9rem'
    },
    h: {
      base: '2.5rem',
      md: '2.5rem'
    },
    objectFit: "contain"
  })))))));
};